import { Image, makeStyles, tokens } from "@fluentui/react-components";
import * as React from "react";

export const UserNotFound: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Image src="/assets/aiir-logo.svg" alt="Aiir" width={"128px"} />
      <h2>User Not Found</h2>
      <div className={styles.textContainer}>
        <p>We were unable to find an Aiir user associate with this email.</p>
        <p>
          Please create an Aiir account through the Aiir web app or sign into Microsoft Office with a different email.
        </p>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    gap: "24px",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    textAlign: "center",
    paddingLeft: "64px",
    paddingRight: "64px",
  },
});
